// extracted by mini-css-extract-plugin
export default {"typeTitle":"components-TicketDelivery-___ticketDelivery__typeTitle___2TPTj"};